import { SumaSaldoInformeDtoProps } from "api/DTOs/SumaSaldoInformeDto"
import { ColoredNumber } from "./ColoredNumber"
import { NeutralNumber } from "./NeutralNumber"

export const SUMAS_SALDOS_COLUMNS = [
  {
    field: "cuenta",
    key: "cuenta",
    style: { width: "5%" },
    className: "tw-font-medium",
  },
  {
    field: "nombre",
    key: "nombre",
    style: { width: "15%" },
  },
  {
    field: "periodo.debe",
    key: "periodo.debe",
    className: "!tw-text-end",
    alignCol: "right",
    style: { width: "5%" },
    body: ({ periodo }: SumaSaldoInformeDtoProps) =>
      NeutralNumber(periodo?.debe ?? 0),
  },
  {
    field: "periodo.haber",
    key: "periodo.haber",
    className: "!tw-text-end",
    alignCol: "right",
    style: { width: "5%" },
    body: ({ periodo }: SumaSaldoInformeDtoProps) =>
      NeutralNumber(periodo?.haber ?? 0),
  },
  {
    field: "periodo.deudor",
    key: "periodo.deudor",
    className: "!tw-text-end",
    alignCol: "right",
    style: { width: "5%" },
    body: ({ periodo }: SumaSaldoInformeDtoProps) =>
      NeutralNumber(periodo?.deudor ?? 0),
  },
  {
    field: "periodo.acreedor",
    key: "periodo.acreedor",
    className: "!tw-text-end",
    alignCol: "right",
    style: { width: "5%" },
    body: ({ periodo }: SumaSaldoInformeDtoProps) =>
      NeutralNumber(periodo?.acreedor ?? 0),
  },
  {
    field: "periodo.saldo",
    key: "periodo.saldo",
    className: "!tw-text-end",
    alignCol: "right",
    style: { width: "5%" },
    body: (rowData: SumaSaldoInformeDtoProps) =>
      ColoredNumber(rowData?.periodo?.saldo ?? 0),
  },
]
